import { render, staticRenderFns } from "./DetailTop.vue?vue&type=template&id=34155060&"
import script from "./DetailTop.vue?vue&type=script&lang=js&"
export * from "./DetailTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports